<template>
  <mask-side-section-container :title="$t('MirrorTo')">
    <v-flex shrink class="mb-2">
      <input-field
        :value="destinationMask"
        label="Internal Destination"
        inputType="other"
        size="large"
      >
        <div>
          <treeselect
            v-model="destinationMask"
            :options="internalMirrorMaskOptions"
            placeholder="Mask"
            class="form-input-select"
            disableFuzzyMatching
          />
        </div>
      </input-field>
      <div style="margin: 4px 20px">
        <v-btn
          small
          block
          round
          class="accent"
          :disabled="!destinationMask"
          @click="mirrorDialog = true"
        >
          <v-icon left>content_copy</v-icon><span>Apply</span>
        </v-btn>
      </div>
    </v-flex>
    <!--    <v-flex shrink>
          <input-field
            :value="selectedMask.mk_default_destination_manhole_id"
            label="External Destination"
            inputType="other"
            size="large"
          >
            <div>
              <treeselect
                v-model="selectedMask.mk_default_destination_manhole_id"
                :options="destinationManholeOptions"
                placeholder="Manhole"
                class="form-input-select"
                disableFuzzyMatching
          />
            </div>
          </input-field>
         <input-field
            :value="selectedMask.mk_default_destination_mask_id"
            label=""
            inputType="other"
            size="large"
          >
            <div>
              <treeselect
                v-model="selectedMask.mk_default_destination_mask_id"
                :options="destinationMaskOptions"
                placeholder="Mask"
                class="form-input-select"
                :disabled="!selectedMask.mk_default_destination_manhole_id"
                disableFuzzyMatching
              />
            </div>
          </input-field>
          <div style="margin: 4px 20px">
            <v-btn
              small
              round
              block
              class="accent"
              :disabled="!selectedMask.mk_default_destination_mask_id"
              @click="mirrorExternally"
            >
              <v-icon left>content_copy</v-icon><span>Apply</span>
            </v-btn>
          </div>
    </v-flex>-->
    <app-dialog-box
      :open="mirrorDialog"
      :title="$t('InternalMirror')"
      :content="$t('ConfirmApplyMirror')"
      :secondary-action-label="$t('No')"
      :main-action-label="$t('Yes')"
      @mainAction="mirrorInternally"
      @secondaryAction="cancelMirror"
    />
  </mask-side-section-container>
</template>

<script>
import InputField from "../../../_Molecules/InputField";
import MaskSideSectionContainer from "./MaskSideSectionContainer";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import { maskTypesMixin } from "@/mixins/forms/masks/maskTypesMixin";
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "MaskMirror",

  components: { AppDialogBox, MaskSideSectionContainer, InputField },

  mixins: [maskTypesMixin],

  data() {
    return {
      destinationManholeOptions: [],
      destinationMaskOptions: [],
      destinationMask: null,
      mirrorDialog: false
    };
  },

  computed: {
    internalMirrorMaskOptions() {
      let masks = this.$store.getters.getManholeMasks;
      let options = [];
      masks.forEach(mask => {
        if (mask.mk_label !== this.selectedMask.mk_label) {
          options.push({ id: mask.mk_label, label: mask.mk_label });
        }
      });
      return options;
    },

    selectedMask() {
      return this.$store.getters.getSelectedMask;
    },

    selectedMaskType() {
      if (this.maskTypes && this.maskTypes.length > 0 && this.selectedMask) {
        return this.getMaskType(this.selectedMask.mk_type);
      }
    }
  },

  methods: {
    ...mapActions(["setMirrorMask"]),

    async mirrorInternally() {
      let masks = this.$store.getters.getManholeMasks;
      let ductsEntry = [];
      let destinationMask = _.cloneDeep(
        masks.find(mask => mask.mk_label === this.destinationMask)
      );

      let horizontalUnits = 12;
      if (this.selectedMaskType && this.selectedMaskType.horizontal_units) {
        horizontalUnits = this.selectedMaskType.horizontal_units;
      }

      let ductsEntryTypes = this.$store.getters.getDuctTypeList;

      if (this.selectedMask && this.selectedMask.duct_entries.length > 0) {
        let index = 1;
        this.selectedMask.duct_entries.forEach(ductEntry => {
          let ductEntrySize = ductsEntryTypes.find(
            ductEntryType => ductEntryType.code === ductEntry.mde_entry_type
          );
          ductsEntry.push({
            mde_label: destinationMask.mk_label + index,
            mde_default_destination: ductEntry.mde_default_destination,
            mde_destination_specific_manhole_uuid:
              ductEntry.mde_destination_specific_manhole_uuid,
            mde_destination_specific_mask:
              ductEntry.mde_destination_specific_mask,
            mde_state: ductEntry.mde_state,
            mde_total_reservation: ductEntry.mde_total_reservation,
            mde_occupancy_rate: ductEntry.mde_occupancy_rate,
            duct_entry_cables: [],
            mde_duct_id: null,
            mde_top:
              horizontalUnits -
              ductEntry.mde_top -
              ductEntrySize.containerWidth,
            mde_left: ductEntry.mde_left,
            mde_entry_type: ductEntry.mde_entry_type
          });
          index++;
        });
      }
      destinationMask.duct_entries = ductsEntry;
      await this.setMirrorMask(destinationMask);
      this.cancelMirror();
    },

    cancelMirror() {
      this.mirrorDialog = false;
      this.destinationMask = null;
    },

    mirrorExternally() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskMirror.vue